<template>
  <v-dialog v-model="readAllDialogOpen"
            persistent
            max-width="400">
    <v-card>
      <v-card-title class="text-h5">
        {{ title }}
      </v-card-title>
      <v-card-text v-html="text"></v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text
               @click="cancel()">
          {{ $t('cancel') }}
        </v-btn>
        <v-btn text
               @click="readAll">
          {{ $t('readAll.action') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    instance: { type: String },
    namespace: { type: String, required: true },
    folder: {
      type: Object,
    },
  },
  computed: {
    readAllDialogOpen: {
      get() {
        return this.$store.state[this.namespace].readAllDialogOpen;
      },
      set(value) {
        this.$store.commit(this.namespace + '/setReadAllDialogOpen', { value });
      },
    },
    title() {
      return this.$t('readAll.' + this.namespace + '.title');
    },
    text() {
      return this.$t('readAll.' + this.namespace + '.text');
    },
  },
  methods: {
    cancel() {
      this.readAllDialogOpen = false;
    },
    async readAll() {
      console.log('readAll');

      await this.$store.dispatch(this.namespace + '/markAllInAndBelowAsRead', { instance: this.instance, folder: this.folder });
      this.readAllDialogOpen = false;
    },
  },
};
</script>
